/* Waitlist client app */
angular.module('mobileReservation', [
	'ngRoute',
	'pusher-angular',
	'config',
	'menuUtils',
	'translator',
	'utils',
	'ngSanitize',
	'ngResource',
])

angular.module('mobileReservation').config([
	'$routeProvider',
	'$locationProvider',
	function ($routeProvider, $locationProvider) {
		//App routes:
		$routeProvider
			//External routes: forces a server page load
			.when('/mobileReservation/:reservationId', {
				templateUrl: '/app/components/menuUtils/mosaico',
			})
			.when('/mobileReservation/menu/:menuId/:reservationId', {
				templateUrl: '/app/components/menuUtils/menuItems',
			})
			.otherwise({ templateUrl: '/app/components/menuUtils/notfound' })
		// enable HTML5mode to disable hashbang urls
		$locationProvider.html5Mode(true)
	},
])

angular.module('mobileReservation').factory('dataFactory', [
	'$http',
	'$location',
	'tgConfig',
	function ($http, $location, tgConfig) {
		$http.defaults.headers.common.apptoken = tgConfig.apptoken
		var urlBase = tgConfig.api + '/'
		urlBase = urlBase.replace('http', $location.protocol())
		var dataFactory = {}

		dataFactory.getApp = function (reservationId) {
			var httpConfig = {
				method: 'GET',
				url: urlBase + 'App/byReservationId/' + reservationId,
				params: { appLabel: 'Mobile Reservation' }
			}

			return $http(httpConfig)
		}

		dataFactory.getReservation = function (reservationId) {
			var httpConfig = {
				method: 'GET',
				url: urlBase + 'Reservation/' + reservationId
			}

			return $http(httpConfig)
		}

		dataFactory.cancelReservation = function (venueId, reservation, customerId) {
			var httpConfig = {
				method: 'PUT',
				url: urlBase + 'Reservation/' + venueId + '/' + reservation._id + '/Cancel',
				data: {
					logs: { customer: customerId, actionType: 'Remove' },
					customer: customerId,
					cancelReason: 'Customer',
					originalReservationData: reservation,
				}
			}

			return $http(httpConfig)
		}

		dataFactory.confirmReservation = function (venueId, reservationId, customer) {
			var customerId = _.get(customer, '_id')

			var httpConfig = {
				method: 'PUT',
				url: urlBase + 'Reservation/' + venueId + '/' + reservationId + '/Confirm',
				data: { logs: { customer: customerId, actionType: 'Update' }, customer: customerId }
			}

			return $http(httpConfig)
		}

		dataFactory.setReservation = function (reservationId, preOrderedItems, customer) {
			var customerId = _.get(customer, '_id')

			var httpConfig = {
				method: 'PUT',
				url: urlBase + 'Reservation/' + reservationId,
				data: { logs: { customer: customerId, actionType: 'Update' }, preOrderedItems: preOrderedItems }
			}

			return $http(httpConfig)
		}

		return dataFactory
	},
])
